<template>
<div>
    <div id="album">

        <div class="photography-section">
            <h1>Album</h1>
            <div class="masonry">
                <img
                    v-for="(photo, index) in photos"
                    :key="index"
                    :src="getImageUrl(photo)"
                    :alt="'Photo ' + (index + 1)"
                />
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Album',
    data() {
        return {
            // Array of photo URLs
            photos: [
                
                'art_0106.jpeg',
                'art_0128.jpeg',
                'art_1850.jpeg',
                'art_2165.jpeg',
                'art_2293.jpeg',
                'art_2360.jpeg',
                'art_2519.jpeg',
                'art_2739.jpeg',
                'art_2753.jpeg',
                'art_2889.jpeg',
                'art_3168.jpeg',
                'art_4402.jpeg',
                'art_6842.jpeg',
                'art_7150.jpeg',
                'art_7832.jpeg',
                'austria.jpeg',
                'france.jpeg',
                'german.jpeg',
                'italy.jpeg',
                'vatican.jpeg',
                'netherland.jpeg',
                'uk.jpeg',
                'church_0578.jpeg',
                'church_0814.jpeg',
                'church_1175.jpeg',
                'church_1833.jpeg',
                'church_1886.jpeg',
                'church_2045.jpeg',
                'church_2947.jpeg',
                'church_3368.jpeg',
                'church_3447.jpeg',
                'church_3698.jpeg',
                'church_3828.jpeg',
                'church_6500.jpeg',
                'church_6949.jpeg',
                'church_8137.jpeg',
                'view_1567.jpeg',
                'view_1613.jpeg',
                'view_2184.jpeg',
                'view_2813.jpeg',
                'view_3884.jpeg',
                'view_3957.jpeg',
                'view_4280.jpeg',
                'view_4443.jpeg',
                'view_4723.jpeg',
                'view_5183.jpeg',
                'view_6798.jpeg',
                'view_6833.jpeg',
                'view_8282.jpeg',
                'view_9860.jpeg',
            ],
        };
    },
    methods: {
        // Method to get the full URL of the image
        getImageUrl(figname) {
            return require(`../../assets/images/${figname}`);
        },
    },
};
</script>

<style scoped>
h1{
    font-size: 30px;
    line-height: 1.5;
    text-align: center;
    color: #111111;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
    font-weight: bolder;
}

/* Main content styles */
#album {
    padding-top: 80px; /* To avoid overlap with the fixed navbar */
    text-align: center;
    width: 1000px;
    margin: 0 auto;
}

.title-section {
    margin-bottom: 20px;
}

/* Photography masonry grid */
.masonry {
    column-count: 3;
    column-gap: 5px;
    padding: 10px;
}

.masonry img {
    width: 100%;
    margin-bottom: 5px;
    display: block;
}
</style>